// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"625":"9709f8d4","821":"2fd3afad"}[chunkId] + ".chunk.js";
};